/* eslint-disable max-lines-per-function */
/* eslint-disable no-irregular-whitespace */
import { Spacing, Text } from '@vkontakte/vkui';
import subscribedToVigboModalImage from 'img/vigbo/subscribedToVigboModal.png';
import React, { memo, useEffect } from 'react';
import { WhatsNewDialog } from 'reactApp/components/WhatsNewDialog/WhatsNewDialog';

import styles from './SubscribedToVigboModal.css';

export interface SubscribedToVigboModalProps {
    onShow?: () => void;
    onClose?: () => void;
    onClick?: () => void;
}

export const SubscribedToVigboModal = memo<SubscribedToVigboModalProps>((data) => {
    useEffect(() => {
        data?.onShow?.();
    }, []);

    return (
        <WhatsNewDialog
            className={styles.root}
            imageUrl={subscribedToVigboModalImage}
            imageWrapperClassName={styles.imageWrapper}
            imageClassName={styles.image}
            contentClassName={styles.content}
            title="Готово! Вы подключили тариф для фотографов от Mail Space и Vigbo"
            content={
                <>
                    <Spacing size={12} />
                    <Text className={styles.text}>
                        Теперь нужно связать аккаунты Mail и Vigbo. Это можно сделать сейчас или позже в разделе Галереи Vigbo
                    </Text>
                    <Spacing size={24} />
                </>
            }
            closeIconClassName={styles.cross}
            primaryButtonText="Связать аккаунты"
            closeBySecondaryButton
            closeAfterClick
            onClick={data?.onClick}
            onClose={data?.onClose}
            imageBgColor="var(--vkui--color_background_modal)"
            buttonTheme="vk"
            dialogSize="large"
            qaId="subscribed-to-vigbo-modal"
            isRebranding
        />
    );
});

SubscribedToVigboModal.displayName = 'SubscribedToVigboModal';
